import { Configuration, RedirectRequest } from "@azure/msal-browser";
import { entraIdConfig } from "../utils/configuration";

const getClientId = () => {
  const clientId = entraIdConfig.clientId;
  if (!clientId || clientId === "{clientId}") {
    console.error("REACT_APP_AZURE_CLIENT_ID is not configured properly");
    return "{clientId}";
  }
  return clientId;
};

const getAuthority = () => {
  const authority = entraIdConfig.authority;
  if (!authority || authority.includes("{tenantId}")) {
    console.error("REACT_APP_AZURE_AUTHORITY is not configured properly");
    return "https://login.microsoftonline.com/{tenantId}";
  }
  return authority;
};

export const msalConfig: Configuration = {
  auth: {
    clientId: getClientId(),
    authority: getAuthority(),
    redirectUri: entraIdConfig.redirectUri,
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    allowNativeBroker: false,
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case 0:
            console.error(message);
            return;
          case 1:
            console.warn(message);
            return;
          case 2:
            console.info(message);
            return;
          case 3:
            console.debug(message);
            return;
        }
      },
    },
  },
};

export const loginRequest: RedirectRequest = {
  scopes: ["User.Read", "openid", "profile", "email"],
};

export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
};
